<template>
  <b-container>
    <b-row class="vh-100 text-center" align-v="center">
      <b-col md="4" offset-md="4">
        <b-form ref="loginForm" @submit.stop.prevent="submitLoginForm">
          <my-input id="my-name" name="my-name" mandatory="true" placeholder="Username" inlinerows="false" variant="test" ref="username" type="email"></my-input>
          <my-input id="my-name" name="my-name" mandatory="true" placeholder="Password" inlinerows="false" variant="test" ref="password" type="password"></my-input>
          <my-button label="Login" variant="box-general" classes="" height="56px" width="90%" type="submit"></my-button>
          <my-button fa="" label="Forgot Password?" variant="link" classes="btn-link" height="48px" width="200px" @onClick="$router.push('password-reset')"></my-button>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import MyInput from "../../components/atoms/Input.vue";
import MyButton from "../../components/atoms/Button.vue";
import Admin from "../../apis/Admin";
import Constants from "../../constants/index";
import router from "../../router/index";
/**
 * Login Page of the application
 */
export default {
  name: "login",

  mounted() {},

  created() {},

  data() {
    return {};
  },

  computed: {},
  methods: {
    async submitLoginForm() {
      try {
        
        this.$store.commit("contentLoading", true);
        const email = this.$refs.username.text;
        const password = this.$refs.password.text;
        const resp = await Admin.login({ email, password });
        this.$store.commit("contentLoading", false);

        if (resp.data.success == true) {

          localStorage.setItem("token", resp.data.data.token);
          await this.$store.commit("setAuthUser", resp.data.data.user);
          const roles = resp.data.data.user.role_assignments_instance.map((assignment) => assignment.role.name);
          await this.$store.commit("setAuthUserRoles", roles);
          router.push("/admin/customers");

        } else {

          this.$fire({
            title: resp.data.message,
            type: "error",
            timer: 3000,
          });

        }
      } catch (error) {

        this.$store.commit("contentLoading", false);
        this.$fire({
          title: Constants.common_error_title,
          type: "error",
          timer: 3000,
        });

      }
    },
  },
  components: {
    MyInput,
    MyButton,
  },
};
</script>
